export default __webpack_public_path__ + "static/media/wbs_support.95ca0e99.jpg";